import React, {useState, useEffect} from "react";
import Section from "./layouts/Section";
import {WebLink, SiteWide} from "./customComponents";
import { useSelector, useDispatch } from 'react-redux';

import {authActions} from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect} from '../redux/selectors/index';
import Helper1, {notify, money, customNormalModalStyles} from '../utility/Helper1';
import {homepage} from '../utility/APIRequests';
import PinAuth from "./customComponents/PinAuth";

// Lucide React Icons
import { 
    Eye, 
    EyeOff, 
    Wallet, 
    Shield, 
    CheckCircle, 
    AlertCircle, 
    History,
    CreditCard,
    User,
    Building2,
    Lock,
    Save,
    Coins,
    Bitcoin,
    Ethereum
} from 'lucide-react';

import {mainStyle, mainColor, header, footer, otherColors} from '../utility/styles';


function WalletComponent({history}){

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const [loading, setloading] = useState(false);
    const [loadingText, setLoadingText] = useState('Loading...');
    const [withdrawalPin, setWithdrawalPin] = useState('');
    const [googleAuth, setGoogleAuth] = useState('');
    const [showPin, setShowPin] = useState(false);
    const [errors, setErrors] = useState({});

    // Wallet state variables
    const [usdttrc20wallet, usdttrc20walletSet] = useState(userData?.usdttrc20wallet ?? '');
    const [usdtbscwallet, usdtbscwalletSet] = useState(userData?.usdtbscwallet ?? '');
    const [btcwallet, btcwalletSet] = useState(userData?.btcwallet ?? '');
    const [bchwallet, bchwalletSet] = useState(userData?.bchwallet ?? '');
    const [ethwallet, ethwalletSet] = useState(userData?.ethwallet ?? '');
    const [ltcwallet, ltcwalletSet] = useState(userData?.ltcwallet ?? '');
    const [usdcwallet, usdcwalletSet] = useState(userData?.usdcwallet ?? '');
    const [xrpwallet, xrpwalletSet] = useState(userData?.xrpwallet ?? '');
    const [adawallet, adawalletSet] = useState(userData?.adawallet ?? '');
    const [dogewallet, dogewalletSet] = useState(userData?.dogewallet ?? '');
    const [dashwallet, dashwalletSet] = useState(userData?.dashwallet ?? '');
    const [xtzwallet, xtzwalletSet] = useState(userData?.xtzwallet ?? '');
    const [dotwallet, dotwalletSet] = useState(userData?.dotwallet ?? '');
    const [linkwallet, linkwalletSet] = useState(userData?.linkwallet ?? '');
    const [xlmwallet, xlmwalletSet] = useState(userData?.xlmwallet ?? '');
    const [etcwallet, etcwalletSet] = useState(userData?.etcwallet ?? '');
    const [uniwallet, uniwalletSet] = useState(userData?.uniwallet ?? '');
    const [pmwallet, pmwalletSet] = useState(userData?.pmwallet ?? '');
    const [bnbwallet, bnbwalletSet] = useState(userData?.bnbwallet ?? '');



    const dispatch = useDispatch();

    // Helper functions for validation
    const validateForm = () => {
        const newErrors = {};
        
        if (!withdrawalPin) {
            newErrors.withdrawalPin = 'Security PIN is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const doAddressChange = (e) => {
        e.preventDefault();

        // Validate form using new validation
        if (!validateForm()) {
            return;
        }

        setloading(true);
        setLoadingText('Updating wallet details...');

        const updateObject = {
            usdttrc20wallet, 
            usdtbscwallet, 
            btcwallet, 
            bchwallet, 
            ethwallet, 
            ltcwallet, 
            usdcwallet, 
            xrpwallet, 
            adawallet, 
            dogewallet, 
            dashwallet, 
            xtzwallet, 
            dotwallet, 
            linkwallet, 
            xlmwallet, 
            etcwallet, 
            uniwallet, 
            pmwallet, 
            bnbwallet, 
            withdrawalPin, 
            googleAuth
        };

        dispatch(authActions.onLogin(`account/account_change/1`, updateObject, response => {
            notify(response.msg, response.code)
            setloading(false);
            if(response.code == 1){
                setWithdrawalPin('');
                setErrors({});
            }
        }));
    }

    useEffect(() => {
       let mat =  userData?.bankdetails?.map((item, detail) => eval(item?.valueJsConstFunction)(item.value));
    }, [])


    const walletDetailsForm = () => {
        return (
            <div className="min-h-screen p-4">
                <div className="max-w-7xl mx-auto pt-8">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                            Wallet Details
                        </h1>
                        <p className="text-xl text-blue-200">
                            Manage your cryptocurrency wallet addresses securely
                        </p>
                    </div>

                    <div className="flex flex-col lg:grid lg:grid-cols-3 gap-8">
                        {/* Current Wallet Overview - Mobile First */}
                        <div className="lg:col-span-1 order-1 lg:order-1">
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-6 shadow-2xl">
                                <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                    <Wallet className="mr-3 text-blue-300" />
                                    Current Wallets
                                </h2>
                                
                                {/* Wallet Info Display */}
                                <div className="space-y-4 mb-6">
                                    {userData?.bankdetails?.slice(0, 3).map((item, index) => {
                                        const walletValue = eval(item.valueJsConst);
                                        return (
                                            <div key={index} className="p-4 rounded-2xl border border-white/20 bg-white/5">
                                                <div className="flex items-center space-x-3">
                                                    <Coins className="text-blue-400" size={24} />
                                                    <div className="flex-1">
                                                        <p className="text-gray-300 text-sm mb-1">{item.abbr} Wallet</p>
                                                        <p className="text-white text-sm font-bold break-all">
                                                            {walletValue ? 
                                                                walletValue.substring(0,8) + '...' + walletValue.slice(-8) : 
                                                                'Not Set'
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Security Info */}
                                <div className="bg-blue-500/10 border border-blue-400/30 rounded-2xl p-4">
                                    <div className="flex items-start">
                                        <AlertCircle className="text-blue-300 mt-1 mr-3 flex-shrink-0" size={20} />
                                        <div>
                                            <p className="text-white text-sm">
                                                <strong>Security:</strong> All wallet addresses are encrypted and stored securely with industry-standard protection.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Wallet Details Form */}
                        <div className="lg:col-span-2 order-2 lg:order-2">
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
                                <form onSubmit={doAddressChange} className="space-y-8">
                                    {/* Wallet Addresses */}
                                    <div>
                                        <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
                                            <Coins className="mr-3 text-blue-300" />
                                            Wallet Addresses
                                        </h3>
                                        
                                        <div className="space-y-6">
                                            {userData?.bankdetails?.map((item, index) => {
                                                const walletValue = eval(item.valueJsConst);
                                                const setWalletValue = eval(item.valueJsConstFunction);
                                                
                                                // Special styling for USDTBSC to make it full width
                                                const isUSDTBSC = item.abbr === 'USDTBSC';
                                                
                                                return (
                                                    <div key={index} className={isUSDTBSC ? 'col-span-full' : ''}>
                                                        <h4 className="text-lg font-semibold text-white mb-3 flex items-center">
                                                            {item.abbr === 'BTC' && <Bitcoin className="mr-2 text-orange-400" size={20} />}
                                                            {item.abbr === 'USDTBSC' && <Coins className="mr-2 text-yellow-400" size={20} />}
                                                            {!['BTC', 'USDTBSC'].includes(item.abbr) && <Coins className="mr-2 text-green-400" size={20} />}
                                                            {item.abbr} Wallet
                                                        </h4>
                                                        <div className="relative">
                                                            <input
                                                                type="text"
                                                                value={walletValue}
                                                                onChange={(e) => setWalletValue(e.target.value)}
                                                                className={`w-full bg-white/10 border-2 border-white/20 
                                                                    rounded-2xl px-6 py-4 text-white text-lg placeholder-gray-300 focus:outline-none 
                                                                    focus:border-blue-400 transition-all duration-300 ${isUSDTBSC ? 'text-center font-mono' : ''}`}
                                                                placeholder={`Enter ${item.abbr} wallet address`}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Security PIN */}
                                    <div>
                                        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                                            <Shield className="mr-3 text-yellow-300" />
                                            Security PIN
                                        </h3>
                                        <div className="relative">
                                            <input
                                                type={showPin ? 'text' : 'password'}
                                                value={withdrawalPin}
                                                onChange={(e) => setWithdrawalPin(e.target.value)}
                                                className={`w-full bg-white/10 border-2 ${errors.withdrawalPin ? 'border-red-400' : 'border-white/20'} 
                                                    rounded-2xl px-6 py-4 pr-16 text-white text-lg placeholder-gray-300 focus:outline-none 
                                                    focus:border-blue-400 transition-all duration-300`}
                                                placeholder="Enter your 4-digit security PIN"
                                                maxLength={4}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPin(!showPin)}
                                                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white transition-colors"
                                            >
                                                {showPin ? <EyeOff size={20} /> : <Eye size={20} />}
                                            </button>
                                        </div>
                                        
                                        {errors.withdrawalPin && (
                                            <p className="text-red-400 text-sm mt-2">{errors.withdrawalPin}</p>
                                        )}
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`w-full py-6 rounded-2xl font-bold text-xl text-white transition-all duration-300 transform
                                            ${loading 
                                                ? 'bg-gray-500 cursor-not-allowed' 
                                                : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 hover:scale-105 shadow-2xl hover:shadow-pink-500/25'
                                            }`}
                                    >
                                        {loading ? (
                                            <div className="flex items-center justify-center">
                                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                                                Updating Wallet Details...
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-center">
                                                <Save className="mr-3" size={24} />
                                                Save Wallet Details
                                            </div>
                                        )}
                                    </button>

                                    {/* Security Notice */}
                                    <div className="text-center">
                                        <p className="text-gray-300 text-sm">
                                            🔒 All wallet addresses are secured with industry-standard encryption
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <SiteWide id="main" title={`Account wallet`}>
            <Section loading={loading} overlayText={loadingText} title={'Account wallet'}>
                {walletDetailsForm()}
            </Section>
        </SiteWide>
    );

}

export default WalletComponent;